<template>
  <notification-icon :unread-count="unreadCount" @toggle="toggleDrawer" />
</template>

<script>
import { mapState } from 'vuex';
import NotificationIcon from './NotificationIcon.vue';

export default {
  name: 'NotificationBell',
  components: { NotificationIcon },
  computed: {
    ...mapState('notifications', ['unreadCount']),
  },
  methods: {
    toggleDrawer() {
      console.log('[NotificationBell] 📣 toggleDrawer called');
      this.$emit('toggle');
    },
  },
};
</script>
